const state = {
  couponDetail: {}
}
const getters = {
  getCouponDetail (state) {
    return state.couponDetail
  }
}
const actions = {
  // fetchParams ({state, commit}, item) {
  //   commit('setParams', item)
  // }
}
const mutations = {
  setCouponDetail (state, item) {
    state.couponDetail = item
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
